import { isToday, parseISO, isBefore } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";

export const calculateMeterExpirationDate = (date: Date) => {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1));
};

export const formatArticleDate = (date: string | null | undefined) => {
  if (!date) return "";
  const dateInstance = parseISO(date);
  const nyTimeZone = "America/New_York";

  try {
    const nyDate = utcToZonedTime(dateInstance, nyTimeZone);

    if (isToday(dateInstance)) {
      return `${format(nyDate, "h:mm a", {
        timeZone: nyTimeZone,
      })} ET`;
    }
  } catch (err) {
    console.error("Timestamp err", err);
  }

  return format(dateInstance, "MMMM d, y");
};

/**
   Confirms if a date is after the editorial cutoff for showing Magazine articles web
   publishing date.
  */
export const shouldRenderIssueName = (date: string | null | undefined) => {
  const CUTOFF_DATE = "2021-08-17";

  if (!date) return false;

  const articleDateInstance = parseISO(date);
  const beforeDateInstance = parseISO(CUTOFF_DATE);

  return isBefore(articleDateInstance, beforeDateInstance);
};

export const formatArticleUpdatedDate = (date: string | null | undefined) => {
  if (!date) return "";
  const dateInstance = parseISO(date);
  const nyTimeZone = "America/New_York";

  try {
    const nyDate = utcToZonedTime(dateInstance, nyTimeZone);
    const time = `${format(nyDate, "h:mm a", {
      timeZone: nyTimeZone,
    })} ET`;

    return isToday(dateInstance)
      ? time
      : `${time} on ${format(nyDate, "MMMM d, y", {
          timeZone: nyTimeZone,
        })}`;
  } catch (err) {
    console.error("'Updated at' timestamp err", err);
  }
};
